/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Unknownuser3Inputs */

const en_settings_reportingapikeys_unknownuser3 = /** @type {(inputs: Settings_Reportingapikeys_Unknownuser3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown user`)
};

/**
* | output |
* | --- |
* | "Unknown user" |
*
* @param {Settings_Reportingapikeys_Unknownuser3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_unknownuser3 = /** @type {((inputs?: Settings_Reportingapikeys_Unknownuser3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Unknownuser3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_unknownuser3(inputs)
});
export { settings_reportingapikeys_unknownuser3 as "settings_reportingApiKeys_unknownUser" }